import type { ReactElement } from 'react';
import { NavLink } from 'react-router-dom';
import { BarChart3, Grid3X3, User } from 'lucide-react';

interface SidebarItem {
  to: string;
  label: string;
  icon: ReactElement;
}

const items: SidebarItem[] = [
  { to: '/spaces', label: 'Spaces', icon: <Grid3X3 size={18} /> },
  { to: '/telemetry', label: 'Telemetry', icon: <BarChart3 size={18} /> },
  { to: '/profile', label: 'User Profile', icon: <User size={18} /> },
];

export function Sidebar(): ReactElement {
  return (
    <aside className="sidebar">
      <nav className="sidebar-nav">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/spaces'}
            className={({ isActive }) =>
              `sidebar-item ${isActive ? 'sidebar-item--active' : ''}`
            }
          >
            <span className="sidebar-item-icon">{item.icon}</span>
            <span className="sidebar-item-label">{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
